var map = {
	"./baac.png": 195,
	"./bank.png": 113,
	"./bay.png": 196,
	"./bbl.png": 197,
	"./bnp.png": 198,
	"./boa.png": 199,
	"./cacib.png": 200,
	"./cimb.png": 201,
	"./citi.png": 202,
	"./db.png": 203,
	"./ghb.png": 204,
	"./gsb.png": 205,
	"./hsbc.png": 206,
	"./ibank.png": 207,
	"./icbc.png": 208,
	"./jpm.png": 209,
	"./kbank.png": 210,
	"./kkp.png": 211,
	"./ktb.png": 212,
	"./lhbank.png": 213,
	"./mb.png": 214,
	"./mega.png": 215,
	"./mufg.png": 216,
	"./promptpay.png": 217,
	"./rbs.png": 218,
	"./sc.png": 219,
	"./scb.png": 220,
	"./smbc.png": 221,
	"./tbank.png": 222,
	"./tcrb.png": 223,
	"./tisco.png": 224,
	"./tmb.png": 225,
	"./truewallet.png": 226,
	"./ttb.png": 227,
	"./uob.png": 228
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 194;